<template>
<!-- book -->
<section class="body-2 ma-0">
    <span v-if="book.publisher" v-html="book.publisher" class="pa-0"></span><span 
      	v-if="book.publisher" class="pa-0">, </span><span 
		v-if="book.address" v-html="book.address" class="pa-0"></span><span 
		v-if="book.address" class="pa-0">, </span><span class="pa-0"
		v-if="year==2100">, to appear</span><span 
		v-if="year < 2100">{{year}}</span>
  </section>
</template>
<script>
export default {
  props:['book','year'],
}
</script>

